import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class WeIcon extends PureComponent {
  render() {
    const { className, type, msg, primary, ...others } = this.props;
    const cls = classNames({
      [`weui-icon-${type}`]: true,
      "weui-icon_msg": msg,
      "weui-icon_msg-primary": primary
    }, className);

    return (
      <i role="img" className={ cls } { ...others }></i>
    );
  }
}

export const IconSuccess = props => <WeIcon type="success" { ...props } />;
export const IconCancel = props => <WeIcon type="cancel" { ...props } />;
export const IconInfo = props => <WeIcon type="info" { ...props } />;
export const IconWarn = props => <WeIcon type="warn" { ...props } />;
export const IconWaiting = props => <WeIcon type="waiting" { ...props } />;
